import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";

export const fetchImage = createAsyncThunk("images/fetchImage", async () => {
  try {
    const res = await request.get(`https://ssl.vipwellness-suite.de/api/pages`);
    const galleryPage = res.data.pages.find((page) => page.name === "gallery");
    return galleryPage ? galleryPage.images.map(img => `https://ssl.vipwellness-suite.de/${img}`) : [];
  } catch (error) {
    console.error("Error fetching images:", error);
    throw error;
  }
});




const initialState = {
  images: [],
  loading: false,
  error: null,
};
const pagesSlice = createSlice({
  name: "images", // يجب أن يتطابق هذا الاسم مع المفتاح في الـ store
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchImage.fulfilled, (state, action) => {
        state.loading = false;
        state.images = action.payload.map(img => 
          `https://ssl.vipwellness-suite.de/${img}`
        );
      })
      .addCase(fetchImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
const imagesSlice = createSlice({
  name: "images",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchImage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchImage.fulfilled, (state, action) => {
      state.loading = false;
      state.images = action.payload; // تم التعديل هنا لجلب صور "gallery" فقط
    });
    builder.addCase(fetchImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default imagesSlice.reducer;
